/**
 * How far an order in production has got, as the words on its status chip.
 *
 * READY is one stored status, but it means two things to a reader. Every piece made: "Ready". Some
 * made and the rest still coming: "Partially ready". The stored status is not changed: this is only
 * how it is read, from the made-against-ordered count the API sends with the order.
 *
 * Anything else reads as its status, unchanged ("IN MANUFACTURING", "SHIPPED"…).
 */
export interface Production { made: number; ordered: number }

export const isPartlyReady = (status: string, p: Production | null | undefined): boolean =>
  status === 'READY' && p != null && p.made < p.ordered;

export function orderStatusText(status: string, p: Production | null | undefined): string {
  return isPartlyReady(status, p) ? 'PARTIALLY READY' : status.replace(/_/g, ' ');
}
